export enum RoutePointStatus {
    Open = 0,
    Current = 5,
    Closed = 10,
    Cancelled = 15,
    Rejected = 20,
}
